export default __webpack_public_path__ + "static/media/btn.65b8109d.png";